// services/CientificoDashboardService.js
import api from '../services/api';

const CientificoDashboardService = {
  async getResumoGeral() {
    try {
      const response = await api.get("/dashboard/cientifico");
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar resumo geral:', error);
      throw error;
    }
  },

  async getEstatisticasAvaliacoes() {
    try {
      const response = await api.get("/avaliacoes");
      const avaliacoes = response.data;

      return {
        total: avaliacoes.length,
        avaliacoes: avaliacoes,
        estatisticas: {
          concluidas: avaliacoes.filter(av => this.verificarConclusao(av)).length,
          mediaGeral: this.calcularMediaGeral(avaliacoes),
          distribuicaoNotas: this.calcularDistribuicaoNotas(avaliacoes)
        },
        recentes: avaliacoes
          .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
          .slice(0, 5)
      };
    } catch (error) {
      console.error('Erro ao buscar estatísticas de avaliações:', error);
      throw error;
    }
  },

  // Métodos auxiliares
  verificarConclusao(avaliacao) {
    return avaliacao.arguenteTotal && 
           avaliacao.presidenteTotal && 
           avaliacao.supervisorTotal;
  },

  calcularMediaGeral(avaliacoes) {
    const avaliacoesConcluidas = avaliacoes.filter(av => this.verificarConclusao(av));
    if (!avaliacoesConcluidas.length) return 0;
    
    const soma = avaliacoesConcluidas.reduce((acc, av) => acc + av.mediaFinal, 0);
    return (soma / avaliacoesConcluidas.length).toFixed(2);
  },

  calcularDistribuicaoNotas(avaliacoes) {
    return avaliacoes.reduce((acc, av) => {
      if (!this.verificarConclusao(av)) return acc;

      const nota = av.mediaFinal;
      if (nota >= 17) acc.excelente++;
      else if (nota >= 15) acc.muitoBom++;
      else if (nota >= 13) acc.bom++;
      else if (nota >= 10) acc.suficiente++;
      else acc.insuficiente++;

      return acc;
    }, {
      excelente: 0,
      muitoBom: 0,
      bom: 0,
      suficiente: 0,
      insuficiente: 0
    });
  }
};

export default CientificoDashboardService;